import Vue from 'vue';

export default {
  state: {
    notifications: [],
  },
  getters: {
    getNotifications: (state) => (scope, source) => {
      return state.notifications
        .filter((notification) => {
          return (
            notification.scope == scope &&
            notification.source == source &&
            !notification.archived &&
            notification.notifications_count > 0
          );
        })
        .reverse();
    },
    allNotificationsByTimeRaised(state) {
      // Sort in reverse time order
      return state.notifications
        .filter((notification) => notification.notifications_count > 0)
        .sort((a, b) => (a.time < b.time ? 1 : -1));
    },
    allNotificationsByTimeCleared(state) {
      return state.notifications
        .filter((notification) => notification.notifications_count > 0)
        .sort((a, b) => {
          if (a.cleared == null && b.cleared == null) {
            return a.time < b.time ? 1 : -1;
          }
          if (a.cleared == null) return -1;
          if (b.cleared == null) return 1;
          return a.cleared < b.cleared ? 1 : -1;
        });
    },
  },
  mutations: {},
  actions: {
    createNotification({ state, dispatch, rootGetters }, { message, data }) {
      console.log(`creating ${message} with event: ${JSON.stringify(data)}`);
      let {
        id,
        type,
        alert_id,
        message: text,
        source,
        metric,
        url,
        criteria,
        raised_at,
        cleared_at,
        updated_at,
        error_value,
        latest_value,
        notifications: notifications_count,
      } = data;

      let scope = null;
      let appearance = null;
      const now = Date.now();
      const raisedAtTime = new Date(raised_at).getTime();
      const timeDifference = now - raisedAtTime;

      if (type == 'notification') {
        scope = 'node';
        appearance = 'information';
        state.notifications.forEach((notification) => {
          if (
            notification.source == source &&
            notification.metric == metric &&
            notification.type == type &&
            !notification.archived
          ) {
            const index = state.notifications.findIndex(
              (n) => n.id === notification.id
            );
            if (index != -1) {
              Vue.set(state.notifications, index, {
                ...state.notifications[index],
                cleared: state.notifications[index].time,
                archived: true,
              });
            }
          }
        });
        const notificationDisplayTime = 30 * 60 * 1000;
        if (timeDifference >= notificationDisplayTime) {
          cleared_at = raised_at;
        } else {
          const remainingTime = notificationDisplayTime - timeDifference;
          dispatch('delayedArchiveNotification', { id, delay: remainingTime });
        }
      } else {
        const duplicates = state.notifications.filter((notification) => {
          return (
            notification.source == source &&
            notification.text == text &&
            !notification.archived
          );
        }).length;
        if (duplicates > 0) return;

        const chainIds = rootGetters.allChainIds;
        const nodeIds = rootGetters.allNodeIds;
        const ingestorIds = rootGetters.allIngestorIds;
        console.log(chainIds);
        console.log(source);
        if (chainIds.includes(source)) {
          scope = 'chain';
          appearance = 'error';
        } else if (nodeIds.includes(source)) {
          scope = 'node';
          appearance = 'error';
        } else if (ingestorIds.includes(source)) {
          scope = 'ingestor';
          appearance = 'warning';
        } else {
          scope = 'ingestor';
          appearance = 'warning';
        }
      }

      const time = new Date(raised_at).getTime();
      const updated = new Date(updated_at).getTime();
      const cleared = cleared_at ? new Date(cleared_at).getTime() : null;
      let is_silenced = false;

      // Check node alerts
      const allNodes = rootGetters.allNodes;
      let nodes = allNodes.filter((node) => node.id == source);
      if (nodes.length > 0) {
        let node = nodes[0];
        let alerts = node.alerts.filter(
          (alert) => alert.metric == metric && alert.url == url
        );
        if (alerts.length > 0) {
          is_silenced = alerts[0].is_silenced;
        }
      }

      // Check chain alerts if not already silenced
      if (!is_silenced) {
        const chains = rootGetters.getChains;
        if (chains) {
          let matchingChains = chains.filter((chain) => chain.id == source);
          if (matchingChains.length > 0) {
            let chain = matchingChains[0];
            let alerts = chain.alerts.filter(
              (alert) => alert.metric == metric && alert.url == url
            );
            if (alerts.length > 0) {
              is_silenced = alerts[0].is_silenced;
            }
          }
        }
      }

      const archived = !!cleared_at || is_silenced;
      state.notifications.push({
        id,
        type,
        alert_id,
        scope,
        source,
        metric,
        url,
        appearance,
        criteria,
        error_value,
        text,
        time,
        latest_value,
        updated,
        cleared,
        archived,
        notifications_count,
      });
    },
    updateNotification({ state }, event_data) {
      console.log('updateNotification');
      const { id, updated_at, notifications: notifications_count } = event_data;
      const index = state.notifications.findIndex(
        (notification) => notification.id === id
      );
      if (index != -1) {
        Vue.set(state.notifications, index, {
          ...state.notifications[index],
          notifications_count,
          updated_at,
        });
      }
    },
    archiveNotification(context, id) {
      console.log('archiveNotification');
      for (var i = 0; i < context.state.notifications.length; i++) {
        if (context.state.notifications[i].id == id) {
          context.state.notifications[i].archived = true;
          if (context.state.notifications[i].type == 'notification') {
            context.state.notifications[i].cleared =
              context.state.notifications[i].time;
          } else {
            context.state.notifications[i].cleared = Math.floor(Date.now());
          }
        }
      }
    },
    delayedArchiveNotification({ dispatch }, { id, delay }) {
      setTimeout(() => {
        dispatch('archiveNotification', id);
      }, delay);
    },
    archiveNotifications(context, event_data) {
      console.log('archiveNotifications');
      const { source, metric, url } = event_data;
      for (var i = 0; i < context.state.notifications.length; i++) {
        if (
          context.state.notifications[i].source == source &&
          context.state.notifications[i].metric == metric &&
          context.state.notifications[i].url == url &&
          !context.state.notifications[i].archived
        ) {
          context.state.notifications[i].archived = true;
          context.state.notifications[i].cleared = Math.floor(Date.now());
        }
      }
    },
    archiveAll(context) {
      for (var i = 0; i < context.state.notifications.length; i++) {
        context.state.notifications[i].archived = true;
      }
    },
    removeAllNotifications(context) {
      context.state.notifications = [];
    },
  },
  modules: {},
};
